document.addEventListener('DOMContentLoaded', () => {
  const consultationOnlyBrands = new Set(['Fondovalle']);

  document.querySelectorAll('.bw-brand').forEach((brand) => {
    const name = brand.querySelector('.bw-brand__name')?.textContent?.trim();
    if (!consultationOnlyBrands.has(name)) return;

    brand.querySelectorAll('.bw-brand__link').forEach((link) => {
      if (link.textContent.trim().toLowerCase() !== 'shop this brand') return;
      link.setAttribute('href', '/pages/appointments');
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.textContent = 'Book a consultation';
    });
  });
});


